import { isCustomBuilderStep, type BuilderStep } from "@/client/constants/builder-steps";

type ResumeLike = { data?: Record<string, any> };

const text = (value: unknown) =>
  String(value ?? "")
    .replace(/<[^>]*>/g, "")
    .trim();

export const isStepComplete = (step: BuilderStep, resume: ResumeLike) => {
  const data = resume.data;
  if (!data) return false;
  if (step === "basics") {
    const basics = data.basics ?? {};
    return Boolean(text(basics.name) && text(basics.email) && text(basics.phone));
  }
  if (step === "summary") return Boolean(text(data.sections?.summary?.content));
  if (step === "finalization") return false;
  if (isCustomBuilderStep(step))
    return Boolean(data.sections?.custom?.[step.slice(7)]?.items?.length);
  return Boolean(data.sections?.[step]?.items?.length);
};
